import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.href
      ? { '@id': `https://wangluoanquan.cn${item.href}`, name: item.label }
      : { name: item.label },
  }));

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: schemaItems,
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
              )}
              {item.href ? (
                <Link
                  to={item.href}
                  className="hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}